// D:\DhammaKnowledgeBase\chat-ui\src\components\MessageInput.js
import React, { useState, useRef, useEffect } from 'react';

const MessageInput = ({ onSendMessage, disabled }) => {
  const [input, setInput] = useState('');
  const textareaRef = useRef(null);

  // Effect to adjust textarea height
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'; // Reset height
      // Set height to scrollHeight, ensuring it doesn't exceed max-height set in CSS
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [input]); // Re-run when input changes

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input.trim() && !disabled) {
      onSendMessage(input);
      setInput('');
      // Reset textarea height after sending message
      if (textareaRef.current) {
        textareaRef.current.style.height = 'auto';
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) { // Enter sends, Shift + Enter creates a new line
      e.preventDefault(); // Prevent default new line behavior
      handleSubmit(e);
    }
  };

  return (
    <form className="message-input-container" onSubmit={handleSubmit}>
      <textarea
        ref={textareaRef}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Ask a question about Dhamma..."
        disabled={disabled}
        rows={1} // Start with one row
      />
      <button type="submit" disabled={disabled}>
        Send
      </button>
    </form>
  );
};

export default MessageInput;